import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { BspceStore } from '../stores/bspce.store';

export const BspceSummaryGuard: CanMatchFn = () => {
  const bspceStore = inject(BspceStore);
  const router = inject(Router);

  if (!bspceStore.loadingStatus().isLoaded) {
    return router.createUrlTree(['bspce', 'form']);
  }

  return true;
};
